<template>
  <div class="content l-c">
    <div class="info">
      <h2>
        <span></span>
        TIP OBRAČUNAVANJA
      </h2>
      <p>Izberite način obračuna električne energije. Uporabljate eno- ali dvotarifno merjenje?</p>
    </div>
    <ul class="counters">
      <li class="counter1">
        <a
          class="cufon"
          v-bind:class="{ selected: isSelected }"
          title="Enotarifno merjenje"
          @click="eno_tarifno()"
        >Enotarifno merjenje</a>
        <div class="etdefaultNoDevice"></div>
      </li>
      <li class="counter2">
        <a
          class="cufon"
          v-bind:class="{ selected: !isSelected }"
          title="Dvotarifno merjenje"
          @click="dvo_tarifno()"
        >Dvotarifno merjenje</a>
        <div class="mtdefaultNoDevice"></div>
        <div class="vtdefaultNoDevice"></div>
      </li>
    </ul>
    <div class="ip">
      <p>
        Odjemalcem, ki imajo enotarifno merjenje, priporočamo, naj preidejo na dvotarifno merjenje, saj bodo na ta način privarčevali pri stroških električne energije.
        <a
          href="http://www.uresnicujmo.si/o_aplikaciji_za_izracun_prihrankov/predstavitev#tarife "
          target="_blank"
          alt="več"
        >Preberite več &gt;</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Counters',
  components: {},
  props: {},
  data: function () {
    return {
      isSelected: true,
    };
  },
  methods: {
    eno_tarifno() {
      this.isSelected = !this.isSelected;
    },
    dvo_tarifno() {
      this.isSelected = !this.isSelected;
    },
  },
};
</script>

<style>
</style>